import * as React from "react";
import { lazy, Suspense } from "react";
import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { useGlobalContext } from "@/context/global-context";
import {
  actionSetCurrentStep,
  actionSetSelectedType,
  actionUpdateUserInfo,
} from "@/store/slices/auth";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hook";

const SejamProfileAuth = lazy(() => {
  if (process.env.REACT_APP_SAJAMI_SAMAT === "true") {
    return import("@/components/pages/sejam-data-profile-samat");
  } else {
    return import("@/components/pages/sejam-data-profile-saderat");
  }
});
console.log("SejamProfileAuth sajam is now");
console.log(process.env.REACT_APP_SAJAMI_SAMAT);
interface IAuthenticationDivProps {
  label?: string;
  onClick?: () => void;
  color?: "primary" | "success";
  textColor?: string;
}

const AuthenticationDiv: React.FunctionComponent<IAuthenticationDivProps> = (
  props,
) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const { showModal, closeModal } = useGlobalContext();
  const dispatcher = useDispatch();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleCompleteInformation = () => {
    props.onClick?.();
    dispatcher(actionSetCurrentStep(null));
    dispatcher(actionSetSelectedType(null));
    dispatcher(actionUpdateUserInfo(null));
    showModal(
      <Suspense
        fallback={
          <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
            <CircularProgress />
          </Box>
        }
      >
        <SejamProfileAuth onClose={closeModal} />
      </Suspense>,
      undefined,
      isMobile ? true : false,
    );
  };

  return (
    <Box
      component="button"
      type="button"
      onClick={handleCompleteInformation}
      sx={{
        display: "inline-flex",
        border: 0,
        font: "inherit",
        alignItems: "center",
        justifyContent: "center",
        p: "8px 16px",
        backgroundColor: `${props.color ?? "primary"}.main`,
        color: props.textColor ?? `${props.color ?? "primary"}.contrastText`,
        "&:hover": {
          backgroundColor: `${props.color ?? "primary"}.dark`,
        },
        borderRadius: "4px",
        cursor: "pointer",
        fontWeight: "500",
        textAlign: "center",
        userSelect: "none",
        maxWidth: "150px",
      }}
    >
      {props.label ?? (user.is_sejami ? t("authenticationagain") : t("authentication"))}
    </Box>
  );
};

export default AuthenticationDiv;
